/**
 * Masks an email address for privacy by partially hiding the local part.
 *
 * @param email - The email address to mask.
 * @returns The masked email string.
 *
 * @example
 * ```ts
 * maskEmail("john.doe@example.com"); // "jo***@example.com"
 * maskEmail("ab@example.com");       // "**@example.com"
 * maskEmail("a@example.com");        // "**@example.com"
 * maskEmail("");                     // ""
 * ```
 */
export function maskEmail(email: string): string {
  if (!email) {
    return email;
  }

  const atIndex = email.indexOf("@");
  if (atIndex === -1) {
    return email;
  }

  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex);

  if (localPart.length <= 2) {
    return `**${domain}`;
  }

  return `${localPart.substring(0, 2)}***${domain}`;
}
